import { useWorkspaceFolders } from '~teacher/hook/workspaces/useWorkspaceFolders';
import { useWorkspaceQuizzes } from '~teacher/hook/workspaces/useWorkspaceQuizzes';

import { WorkspaceFolder } from '../../../api/workspaces/folders/types';
import { WorkspaceQuiz } from '../../../api/workspaces/quiz/types';

export type WorkspaceItem = WorkspaceQuiz | WorkspaceFolder;
interface UseWorkspaceItemParam {
  workspaceId: string;
  enabled?: boolean;
  isDeleted?: boolean;
}

/**
 * Hook to retrieve the collective workspace data
 * @param options
 * @param options.workspaceId  the id of the workspace
 */
export function useWorkspaceItems({
  workspaceId,
  enabled = true,
  isDeleted,
}: UseWorkspaceItemParam) {
  const workspaceQueries = [
    useWorkspaceQuizzes({
      workspaceId,
      enabled,
      isDeleted,
    }),
    useWorkspaceFolders({
      workspaceId,
      enabled,
      isDeleted,
    }),
  ];

  const isFetching = workspaceQueries.some((query) => query.isFetching);

  const data =
    !enabled || isFetching
      ? []
      : workspaceQueries
          .map((query) => query.data)
          .filter(Boolean)
          .reduce((accumulator, value) => [...accumulator, ...value], []);

  return {
    workspaceQueries: workspaceQueries,
    isFetching: isFetching,
    data: data,
  };
}
